<template>
  <v-row align="start" justify="center">
    <v-col cols="12">
      <v-data-iterator
        :items="Object.values(traders)"
        :items-per-page.sync="itemsPerPage"
        :footer-props="{ itemsPerPageOptions }"
      >
        <template v-slot:default="props">
          <v-row align="start" justify="center">
            <v-col v-for="item in props.items" :key="item.id" cols="12" sm="6" md="4" lg="4">
              <Card :item="item"></Card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { TRADER } from "@/store/actions.type";
import Card from "@/components/accounts/Card.vue";

export default {
  name: "Traders",
  components: {
    Card
  },
  data() {
    return {
      itemsPerPageOptions: [6, 12, 18],
      itemsPerPage: 6
    };
  },
  computed: {
    ...mapGetters(["traders", "isAuthenticated"])
  },
  mounted() {
    if (this.traders.length == 0) {
      this.$store.dispatch(TRADER.FETCH);
    }
  }
};
</script>
<style></style>
